import { INationalContacts } from "../types";
import CarrierContacts from "./CarrierContacts";
interface NationalContactProps {
  nationalContacts?: Array<INationalContacts>;
}
const defaultNatContact = [
  {
    parentRow: true,
    tableName: "nationalContacts",
  },
] as Array<INationalContacts>;
const CarrierNationalContact = ({
  nationalContacts = defaultNatContact,
}: NationalContactProps): JSX.Element => {
  return (
    <div className="bg-white box-shadow rounded-lg h-full pb-4">
      <div className="px-3 py-2 text-primary font-bold text text-xs">
        National Contact
      </div>
      <CarrierContacts
        carrierContacts={nationalContacts}
        showNationalFields={true}
      />
    </div>
  );
};

export default CarrierNationalContact;
